/**
 * v1 GENAU-APP-BACKEND reads `grouping.perencanaan_sampling`, not `grouping.air`.
 * @see GENAU-APP-BACKEND/perubahan-db.txt (1=air, 2=udara, 3=LB3)
 */
export const PERENCANAAN_SAMPLING_AIR = 1;
export const PERENCANAAN_SAMPLING_UDARA = 2;
export const PERENCANAAN_SAMPLING_LB3 = 3;

export type SamplingPlanAirGroup = 'air' | 'non_air';

export type GroupingAirSignalFields = {
  perencanaan_sampling?: unknown;
};

/** Map v1 perencanaan_sampling to air / non_air tab group. Returns null when unset or unknown. */
export function airGroupFromPerencanaanSampling(value: unknown): SamplingPlanAirGroup | null {
  if (value == null || value === '') return null;
  const n = Math.floor(Number(value));
  if (!Number.isFinite(n) || n <= 0) return null;
  if (n === PERENCANAAN_SAMPLING_AIR) return 'air';
  if (n === PERENCANAAN_SAMPLING_UDARA || n === PERENCANAAN_SAMPLING_LB3) return 'non_air';
  return null;
}

/** Resolve air/non-air from populated grouping — v1 signal only. */
export function airGroupFromGroupingFields(
  grouping: GroupingAirSignalFields | null | undefined,
): SamplingPlanAirGroup | null {
  if (!grouping) return null;
  return airGroupFromPerencanaanSampling(grouping.perencanaan_sampling);
}

export function jenisPengukuranAirFlagFromGrouping(
  grouping: GroupingAirSignalFields | null | undefined,
): boolean | null {
  const group = airGroupFromGroupingFields(grouping);
  if (group === 'air') return true;
  if (group === 'non_air') return false;
  return null;
}
